import jwt from 'jwt-simple';
import * as CONSTS from '../../const';
import { getTokenFromStorage } from '../../shared';

const secret = '';
const MILLISECONDS = 1000;

export let decode = (authToken = '') => {
  let decode = jwt.decode(authToken, secret, true);
  return decode;
};

export let getUserIdByToken = (authToken = '') => {
  let decode = jwt.decode(authToken, secret, true);
  return decode.id;
};

export let getSchoolId = authToken => {
  let decoded = jwt.decode(authToken, secret, true);
  return decoded.school_id;
};

export let isValidUserObject = authToken => {
  let decoded = jwt.decode(authToken, secret, true);
  return decoded.id && decoded.authorities[0] && decoded.school_id;
};

export let getUserId = () => {
  if (!getTokenFromStorage()) {
    return '';
  }
  let authToken = getTokenFromStorage();
  let decoded = jwt.decode(authToken, secret, true);
  return decoded.id;
};

export let getUserRole = () => {
  if (!getTokenFromStorage()) {
    return '';
  }
  let authToken = getTokenFromStorage();
  let decoded = jwt.decode(authToken, secret, true);

  // TODO:F Estudiar casos
  return decoded.authorities[0];
};

export let getTokenExpiration = authToken => {
  let decoded = jwt.decode(authToken, secret, true);
  return new Date(parseInt(decoded.exp, 10) * MILLISECONDS);
};

export let hasExpired = authToken => {
  return getTokenExpiration(authToken) < new Date();
};

export let timeExpiredInMinutes = authToken => {
  const today = new Date();
  const diffMs = today - getTokenExpiration(authToken);
  return Math.floor(diffMs / 1000 / 60);
};

export let isUserInstructor = () => {
  const role = getUserRole();
  return role === CONSTS.ROLE.INSTRUCTOR;
};

export let isUserStudent = () => {
  const role = getUserRole();
  return role === CONSTS.ROLE.STUDENT;
};

export let getUserInstitutionId = authToken => {
  let decoded = jwt.decode(authToken, secret, true);
  return decoded.school_id;
};

export let getUserCustomerId = authToken => {
  let decoded = jwt.decode(authToken, secret, true);
  return decoded.customer_id;
};
